// extracted by mini-css-extract-plugin
export default {"promo":"VacancyPage_promo__XYBBb","promoDescr":"VacancyPage_promoDescr__fUdKV","promoRectangle":"VacancyPage_promoRectangle__FugCG","vacancies":"VacancyPage_vacancies__nJxiO"};